import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import dayjs from 'dayjs';
import CreateEnquiry from '../../components/Manage/Enquiry/CreateEnquiry';
import { EnquiryService } from '../../Services/Manage/EnquiryService';
import { UserService } from '../../Services/Manage/UserService';
import { Card, Typography, Space, Spin } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import useMessage from 'antd/es/message/useMessage';

const getPermission = (link) => {
  try {
    const raw = localStorage.getItem("ome_permission");
    const parsed = JSON.parse(raw);
    const permissions = Array.isArray(parsed) ? parsed : JSON.parse(parsed);
    return permissions.find(p => p.link === link) || { add: false, edit: false, delete: false, read: false };
  } catch { return { add: false, edit: false, delete: false, read: false }; }
};

const CreateEnquiryPage = () => {
  const navigate = useNavigate();
  const { eqId } = useParams();          // present only on edit route
  const isEdit = !!eqId;

  const [generatedEQNo, setGeneratedEQNo] = useState('');
  const [apiMessage, msgContext] = useMessage();
  const [record, setRecord] = useState(null);
  const [loading, setLoading] = useState(isEdit); // only load when editing
  const perm = getPermission('/enquiry');

  useEffect(() => {
    if (!isEdit) return;
    const load = async () => {
      try {
        const res = await EnquiryService.getEnquiryDetailsById(eqId);
        if (res.status) {
          const r = res.data;
          setRecord({
            ...r,
            note: r.notes,
            eq_no: r.eq_id,
   eq_date: r.eq_date ? dayjs(r.eq_date) : null,
            expected_go_live: r.expected_go_live ? dayjs(r.expected_go_live) : null,   // ADD
            n_follow_up: r.n_follow_up ? dayjs(r.n_follow_up) : null,
          });
        } else {
          apiMessage.error(res.message);
        }
      } catch {
        apiMessage.error("Failed to load enquiry");
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [eqId, isEdit]);

  // permission check: add for create, edit for edit
  if (isEdit ? !perm.edit : !perm.add) {
    return (
      <Card>
        <Typography.Text type="danger">
          You don't have permission to {isEdit ? 'edit' : 'create'} an enquiry.
        </Typography.Text>
      </Card>
    );
  }

const handleSubmit = async (values) => {
    const user = await UserService.getOmeUser();
    const _ome = JSON.parse(localStorage.getItem("ome_user") || "{}");
    const _actionBy = _ome?.name || _ome?.user_name || "";
    let payload = { ...values, added_by: user.uid, action_by: _actionBy };

    if (isEdit) {
      payload = { ...payload, edit_e_id: record.e_id, edit_c_id: record.c_id };
    }

    const request = isEdit
      ? await EnquiryService.updateEnquiries(payload)
      : await EnquiryService.createEnquiries(payload);

    if (request.status) {
      apiMessage.success(request.message);
      setTimeout(() => navigate('/enquiry'), 1000);
    } else {
      apiMessage.error(request.message);
    }
  };

  return (
    <Card
      title={
        <Space>
          <ArrowLeftOutlined
            style={{ cursor: 'pointer', fontSize: 20 }}
            onClick={() => navigate('/enquiry')}
          />
          <Typography.Title level={4} style={{ margin: 0 }}>
            {isEdit ? 'Edit' : 'Create'} Enquiry{' '}
            {(isEdit ? eqId : generatedEQNo) && `— ${isEdit ? eqId : generatedEQNo}`}
          </Typography.Title>
        </Space>
      }
    >
      {msgContext}
      {loading ? (
        <Spin />
      ) : (
        <CreateEnquiry
          initialValues={isEdit ? record : null}
          onSubmit={handleSubmit}
          onCancel={() => navigate('/enquiry')}
          handleEQNo={setGeneratedEQNo}
        />
      )}
    </Card>
  );
};

export default CreateEnquiryPage;